import React, { useRef } from "react";
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import RoleAccessSearch from "./RoleAccessSearch";
import RoleAccessDatatable from "./RoleAccessdatatable";
import UserService from "../../services/user/user.service";
import { useState } from "react";

const RoleAccessMain: React.FC = () => {
    const toast = useRef<Toast>(null);
    const [hasSearched, setHasSearched] = useState(false);
    const [assignedRoles, setAssignedRoles] = useState([]);
    const [unassignedRoles, setUnassignedRoles] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);

    const handleSearch = async (userId: number | null) => {
        console.log("Searching for user ID:", userId);
        setSelectedUserId(userId);
        setHasSearched(true);

        if (userId) {
            try {
                const response = await UserService.getUserRoles(userId); // replace with actual service
                setAssignedRoles(response.assignedRoles);
                setUnassignedRoles(response.unassignedRoles);
            } catch (error) {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch roles' });
            }
        }
    };

    return (
        <div className="layout-content mt-3 mb-3">
            <Toast ref={toast} />

            <div className="col-12">
                <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                    <h5 className="ml-1 mb-0">Role Assignment</h5>
                </div>
            </div>

            <RoleAccessSearch onSearch={handleSearch} />

            {hasSearched && (
                <RoleAccessDatatable
                    assignedRoles={assignedRoles}
                    unassignedRoles={unassignedRoles}
                    userId={selectedUserId}
                    onRefresh={() => handleSearch(selectedUserId)}
                />
            )}
        </div>
    );
};

export default RoleAccessMain;